import { create } from 'zustand';
import type { AuthResult, DeviceRole } from '@taj/types';

interface DeviceState {
  role: DeviceRole | null;
  station: string | null;
  auth: AuthResult | null;
  setRole: (role: DeviceRole, station?: string | null) => void;
  resetRole: () => void;
  setAuth: (auth: AuthResult | null) => void;
}

const savedRole = localStorage.getItem('taj_device_role') as DeviceRole | null;
const savedStation = localStorage.getItem('taj_device_station');
const savedAuth = localStorage.getItem('taj_auth');

export const useDevice = create<DeviceState>((set) => ({
  role: savedRole,
  station: savedStation,
  auth: savedAuth ? JSON.parse(savedAuth) : null,
  setRole: (role, station = null) => {
    localStorage.setItem('taj_device_role', role);
    if (station) localStorage.setItem('taj_device_station', station);
    else localStorage.removeItem('taj_device_station');
    set({ role, station });
  },
  resetRole: () => {
    localStorage.removeItem('taj_device_role');
    localStorage.removeItem('taj_device_station');
    set({ role: null, station: null });
  },
  setAuth: (auth) => {
    if (auth) {
      localStorage.setItem('taj_auth', JSON.stringify(auth));
      localStorage.setItem('taj_token', auth.token);
    } else {
      localStorage.removeItem('taj_auth');
      localStorage.removeItem('taj_token');
    }
    set({ auth });
  },
}));
